import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Plus } from 'lucide-react';

export default function CarTypeDialog({
  showCarTypeDialog,
  setShowCarTypeDialog,
  editingCarType,
  setEditingCarType,
  carTypeForm,
  setCarTypeForm,
  resetCarTypeForm,
  handleCreateCarType,
  handleUpdateCarType
}) {
  return (
    <Dialog open={showCarTypeDialog} onOpenChange={(open) => {
      setShowCarTypeDialog(open);
      if (!open) {
        setEditingCarType(null);
        resetCarTypeForm();
      }
    }}>
      <DialogTrigger asChild>
        <Button className="bg-gradient-to-r from-purple-600 to-pink-600">
          <Plus className="w-5 h-5 mr-2" />
          Add Car Type
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingCarType ? 'Edit Car Type' : 'Add New Car Type'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={editingCarType ? handleUpdateCarType : handleCreateCarType} className="space-y-4">
          <div>
            <Label htmlFor="car_type_name">Name *</Label>
            <Input
              id="car_type_name"
              placeholder="e.g., Compact Sedan"
              value={carTypeForm.name}
              onChange={(e) => setCarTypeForm({ ...carTypeForm, name: e.target.value })}
              required
            />
          </div>
          <div>
            <Label htmlFor="car_type_description">Description *</Label>
            <Textarea
              id="car_type_description"
              placeholder="Brief description of this car type"
              value={carTypeForm.description}
              onChange={(e) => setCarTypeForm({ ...carTypeForm, description: e.target.value })}
              required
            />
          </div>
          <div>
            <Label htmlFor="car_type_price_per_day">Price per Day (€) *</Label>
            <Input
              id="car_type_price_per_day"
              type="number"
              min="0"
              step="0.01"
              placeholder="50.00"
              value={carTypeForm.price_per_day}
              onChange={(e) => setCarTypeForm({ ...carTypeForm, price_per_day: parseFloat(e.target.value) || 0 })}
              required
            />
          </div>
          <Button type="submit" className="w-full bg-gradient-to-r from-purple-600 to-pink-600">
            {editingCarType ? 'Update Car Type' : 'Create Car Type'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
